import axios from 'axios';
import { handleError, handleResponse } from '../utils/ServideHelper';
import { CamposVisiveisFabricaNo } from 'ppcp-utils/dist/entities/ppcp';

export const getCapacidadesFabricas = (data) => {
    return new Promise((resolve, reject) => {
        const config = {
            url: `/capacityrule/capacidade/fabrica/${data}`,
            method: 'get',
            maxContentLength: Infinity,
        };

        axiosExecute(config, resolve, reject);
    });
};

export const getResumido = (datas) => {
    return new Promise((resolve, reject) => {
        const config = {
            url: '/dadomestre/planejamento/dados',
            method: 'post',
            data: datas,
            maxContentLength: Infinity,
        };

        axiosExecute(config, resolve, reject);
    });
};

export const getResumidoPorCor = (datas) => {
    return new Promise((resolve, reject) => {
        const config = {
            url: '/dadomestre/planejamento-por-cor',
            method: 'post',
            data: datas,
            maxContentLength: Infinity,
        };

        axiosExecute(config, resolve, reject);
    });
};

export const getFiltros = (tabelas) => {
    return new Promise((resolve, reject) => {
        const config = {
            url: '/dadomestre/planejamento/caracteristicas',
            data: { tabelas },
            method: 'get',
            maxContentLength: Infinity,
        };

        axiosExecute(config, resolve, reject);
    });
};

export const getCapacidadesByData = (data) => {
    return new Promise((resolve, reject) => {
        const config = {
            url: '/capacityrule/capacidade/data',
            method: 'get',
            params: { data },
            maxContentLength: Infinity,
        };

        axiosExecute(config, resolve, reject);
    });
};

export const salvarFiltrosFabricaNoPorUsuario = (usuario, camposVisiveis) => {
    const data = new CamposVisiveisFabricaNo({ usuario, camposVisiveis });

    return new Promise((resolve, reject) => {
        const config = {
            url: '/capacityrule/fabrica-no/save-filtros',
            method: 'post',
            data,
        };

        axiosExecute(config, resolve, reject);
    });
};

export const obterFiltrosFabricaNoPorUsuario = (usuario) => {
    return new Promise((resolve, reject) => {
        const config = {
            url: '/capacityrule/fabrica-no/get-filtros?usuario=' + usuario,
            method: 'get',
            maxContentLength: Infinity,
        };

        axiosExecute(config, resolve, reject);
    });
};

export const getCapacidades = (_) => {
    return new Promise((resolve, reject) => {
        const config = {
            url: '/capacityrule/capacidade',
            method: 'get',
            maxContentLength: Infinity,
        };

        axiosExecute(config, resolve, reject);
    });
};

export const getDatas = () => {
    return new Promise((resolve, reject) => {
        const config = {
            url: '/dadomestre/planejamento/datas',
            method: 'get',
            maxContentLength: Infinity,
        };

        axiosExecute(config, resolve, reject);
    });
};

export const getDetalhado = (filtro) => {
    return new Promise((resolve, reject) => {
        const config = {
            url: '/dadomestre/planejamento/dadospormaterial',
            method: 'get',
            params: filtro,
            maxContentLength: Infinity,
        };

        axiosExecute(config, resolve, reject);
    });
};

export const atualizaQuantidade = async (p) => {
    const config = {
        url: '/dadomestre/planejamento/atualizaQuantidade',
        method: 'put',
        params: p,
        maxContentLength: Infinity,
    };
    let result = await axios(config);
    return result;
};

export const atualizaPercEstSeg = async (p) => {
    const config = {
        url: '/dadomestre/planejamento/atualizaPercEstSeg',
        method: 'put',
        params: p,
        maxContentLength: Infinity,
    };
    await axios(config);
};

export const atualizaPercEstSegLote = async (materiais) => {
    return new Promise((resolve, reject) => {
        const config = {
            url: '/dadomestre/planejamento/atualizaPercEstSegLote',
            method: 'put',
            data: materiais,
            maxContentLength: Infinity,
        };

        axiosExecute(config, resolve, reject);
    });
};

export const saveCapacidades = async (capacidades, data) => {
    const config = {
        url: '/capacityrule/capacidade',
        method: 'post',
        data: { capacidades, data },
        maxContentLength: Infinity,
    };
    await axios(config);
};

export const saveErp = async (login, tabelas) => {
    const config = {
        url: '/dadomestre/planejamento/salvarErp',
        method: 'post',
        timeout: 0,
        data: { login, tabelas },
        maxContentLength: Infinity,
    };
    return await axios(config);
};

export const getSaveErp = (idProcesso) => {
    return new Promise((resolve, reject) => {
        const config = {
            url: '/dadomestre/planejamento/salvarErp',
            method: 'get',
            maxContentLength: Infinity,
        };

        axiosExecute(config, resolve, reject);
    });
};

export const saveFabrica = async (p) => {
    const config = {
        url: '/dadomestre/planejamento/salvarFabrica',
        method: 'post',
        data: p,
        maxContentLength: Infinity,
    };
    await axios(config);
};

export const saveFabricaEmLote = async (data) => {
    return new Promise((resolve, reject) => {
        const config = {
            url: '/dadomestre/planejamento/salvarFabricaEmLote',
            method: 'post',
            data,
            maxContentLength: Infinity,
        };

        axiosExecute(config, resolve, reject);
    });
};

export const atribuirAlteradoEmLote = async (data) =>
    new Promise((resolve, reject) => {
        const config = {
            url: '/dadomestre/planejamento/atribuirAlteradoEmLote',
            method: 'put',
            data,
            maxContentLength: Infinity,
        };

        axiosExecute(config, resolve, reject);
    });

export const atribuirAlteradoPorCorEmLote = async (data) =>
    new Promise((resolve, reject) => {
        const config = {
            url: '/dadomestre/planejamento/atribuirAlteradoPorCorEmLote',
            method: 'put',
            data,
            maxContentLength: Infinity,
        };

        axiosExecute(config, resolve, reject);
    });

export const saveFoto = async (p) => {
    return new Promise((resolve, reject) => {
        const config = {
            url: '/dadomestre/planejamento/gravarHistorico',
            method: 'post',
            data: p,
            maxContentLength: Infinity,
        };

        axiosExecute(config, resolve, reject);
    });
};

export const getPermanencias = async (materiais) => {
    return new Promise((resolve, reject) => {
        const config = {
            url: '/dadomestre/planejamento/permanencia',
            method: 'post',
            data: { materiais },
            maxContentLength: Infinity,
        };

        axiosExecute(config, resolve, reject);
    });
};

export const getMateriaisPermanente = async (_) => {
    return new Promise((resolve, reject) => {
        const config = {
            url: '/dadomestre/planejamento/materiais/permanente',
            method: 'get',
            maxContentLength: Infinity,
        };

        axiosExecute(config, resolve, reject);
    });
};

export const isProcessing = async (id) => {
    return new Promise((resolve, reject) => {
        const config = {
            url: `/dadomestre/processing/${id}`,
            method: 'get',
            maxContentLength: Infinity,
        };

        axiosExecute(config, resolve, reject);
    });
};

export const isAnyProcessing = async () => {
    return new Promise((resolve, reject) => {
        const config = {
            url: `/dadomestre/processing/anyProcessing`,
            method: 'get',
            maxContentLength: Infinity,
        };

        axiosExecute(config, resolve, reject);
    });
};

export const isProcessingByLogin = async (origin) => {
    return new Promise((resolve, reject) => {
        const config = {
            url: '/dadomestre/processing/login',
            data: { origin },
            method: 'get',
            maxContentLength: Infinity,
        };

        axiosExecute(config, resolve, reject);
    });
};

export const isProcessingByOrigin = async (origin) => {
    return new Promise((resolve, reject) => {
        const config = {
            url: '/dadomestre/processing/origin',
            method: 'get',
            params: { origin: origin, processing: true },
            maxContentLength: Infinity,
        };

        axiosExecute(config, resolve, reject);
    });
};

export const setAntecipacoes = async (dados) => {
    return new Promise((resolve, reject) => {
        const config = {
            url: '/dadomestre/planejamento/antecipacoes',
            method: 'post',
            data: dados,
            maxContentLength: Infinity,
        };

        axiosExecute(config, resolve, reject);
    });
};

export const limparAntecipacoes = async (materiais, cor, tabelas) => {
    return new Promise((resolve, reject) => {
        const config = {
            url: '/dadomestre/planejamento/antecipacoes/delete',
            method: 'post',
            data: { materiais, cor, tabelas },
            maxContentLength: Infinity,
        };

        axiosExecute(config, resolve, reject);
    });
};

export const limparAntecipacoesPorCor = async (materiais, tabelas) => {
    return new Promise((resolve, reject) => {
        const config = {
            url: '/dadomestre/planejamento/antecipacoes/delete',
            method: 'post',
            data: { materiais, antecipacaoPorCor: true, tabelas },
            maxContentLength: Infinity,
        };

        axiosExecute(config, resolve, reject);
    });
};

export const atualizarDadosPorCor = async (data) => {
    return new Promise((resolve, reject) => {
        const config = {
            url: '/dadomestre/planejamento-por-cor/update',
            method: 'post',
            data,
            maxContentLength: Infinity,
        };

        axiosExecute(config, resolve, reject);
    });
};

export const setLoteMinimo = async (dados) => {
    return new Promise((resolve, reject) => {
        const config = {
            url: '/dadomestre/planejamento/loteminimo',
            method: 'post',
            data: dados,
            maxContentLength: Infinity,
        };

        axiosExecute(config, resolve, reject);
    });
};

export const setLoteMinimoPorCor = async (dados) => {
    return new Promise((resolve, reject) => {
        const config = {
            url: '/dadomestre/planejamento/loteminimo-cor',
            method: 'post',
            data: dados,
            maxContentLength: Infinity,
        };

        axiosExecute(config, resolve, reject);
    });
};

export const setMultiploIgualizado = async (dados) => {
    return new Promise((resolve, reject) => {
        const config = {
            url: '/dadomestre/multiplo-igualizavel/aplicar',
            method: 'post',
            data: dados,
            maxContentLength: Infinity,
        };

        axiosExecute(config, resolve, reject);
    });
};

export const setGastar = async (dados) => {
    return new Promise((resolve, reject) => {
        const config = {
            url: '/dadomestre/planejamento/gastar',
            method: 'post',
            data: dados,
            maxContentLength: Infinity,
        };

        axiosExecute(config, resolve, reject);
    });
};

export const getNumPv = async () => {
    return new Promise((resolve, reject) => {
        const config = {
            url: '/dadomestre/carga/numeropv',
            method: 'get',
        };

        axiosExecute(config, resolve, reject);
    });
};

export const getVersaoUsuario = async () => {
    let versions = await axios.get('/dadomestre/versao/versaoUsuario');
    return versions.data.map((x) => ({
        value: x._id,
        label: x.nome + (x.login !== '' ? ' - ' + x.login : ''),
    }));
};
export const gerarNovaVersao = async (data) => {
    return new Promise((resolve, reject) => {
        const config = {
            url: '/dadomestre/versao/gerarNovaVersao',
            method: 'post',
            data,
        };

        axiosExecute(config, resolve, reject);
    });
};

export const alterarDados = async (data) => {
    return new Promise((resolve, reject) => {
        const config = {
            url: '/dadomestre/planejamento/alterarDados',
            method: 'post',
            data,
            timeout: 0,
        };

        axiosExecute(config, resolve, reject);
    });
};

export const getHistoricoVersao = async (data) => {
    return new Promise((resolve, reject) => {
        const config = {
            url: '/dadomestre/historico/versoes',
            method: 'get',
            params: data,
            timeout: 0,
        };

        axiosExecute(config, resolve, reject);
    });
};

export const aplicarEstoqueFinalFechamento = async (data) => {
    return new Promise((resolve, reject) => {
        const config = {
            url: '/dadomestre/historico/aplicarEstoqueFinalFechamento',
            method: 'post',
            data,
            timeout: 0,
        };

        axiosExecute(config, resolve, reject);
    });
};

export const aplicarConjunto = async (data) => {
    return new Promise((resolve, reject) => {
        const config = {
            url: '/dadomestre/conjunto/aplicar-cima',
            method: 'post',
            data,
            timeout: 0,
        };

        axiosExecute(config, resolve, reject);
    });
};

export const aplicarConjuntoParaBaixo = async (data) => {
    return new Promise((resolve, reject) => {
        const config = {
            url: '/dadomestre/conjunto/aplicar-baixo',
            method: 'post',
            data,
            timeout: 0,
        };

        axiosExecute(config, resolve, reject);
    });
};

export const aplicarJustificativa = async (data) => {
    return new Promise((resolve, reject) => {
        const config = {
            url: '/dadomestre/justificativa/',
            method: 'post',
            data,
            timeout: 0,
        };

        axiosExecute(config, resolve, reject);
    });
};

export const aplicarJustificativaPorCor = async (data) => {
    return new Promise((resolve, reject) => {
        const config = {
            url: '/dadomestre/justificativa?porCor=true',
            method: 'post',
            data,
            timeout: 0,
        };

        axiosExecute(config, resolve, reject);
    });
};

export const removerJustificativa = async (data) => {
    return new Promise((resolve, reject) => {
        const config = {
            url: '/dadomestre/justificativa/',
            method: 'delete',
            data,
            timeout: 0,
        };

        axiosExecute(config, resolve, reject);
    });
};

export const saveJustificativa = async (data) => {
    return new Promise((resolve, reject) => {
        const config = {
            url: '/dadomestre/justificativa/save',
            method: 'post',
            data,
            timeout: 0,
        };

        axiosExecute(config, resolve, reject);
    });
};
export const deleteJustificativa = async (id) => {
    return new Promise((resolve, reject) => {
        const config = {
            url: `/dadomestre/justificativa/${id}`,
            method: 'delete',
            timeout: 0,
        };

        axiosExecute(config, resolve, reject);
    });
};

export const getJustificativa = async () => {
    return new Promise((resolve, reject) => {
        const config = {
            url: '/dadomestre/justificativa/',
            method: 'get',
            timeout: 0,
        };

        axiosExecute(config, resolve, reject);
    });
};

export const getCargaDateAndTime = async () => {
    const endpoint = window.location.hash.includes('planejamento-por-cor') ? 'get-carga-date-por-cor' : 'get-carga-date';
    return new Promise((resolve, reject) => {
        const config = {
            url: '/dadomestre/carga/' + endpoint,
            method: 'get',
        };

        axiosExecute(config, resolve, reject);
    });
};

export const axiosExecute = (config, resolve, reject) => {
    axios(config).then(handleResponse(resolve)).catch(handleError(reject));
};
